export default __webpack_public_path__ + "b639c6a91a24da9ff26cfcf1631a8b4f.wav";